import NotFoundPage from './notFound';

export default NotFoundPage;
